import React, { useState, useEffect } from 'react';
import useStore from '../../../../store';
import { useTranslation } from 'react-i18next';
import './SlidingPuzzle.css';
import '../../ui/ArcadeShared.css';

const SlidingPuzzle = ({ socket, onClose, timeLeft }) => {
  const { t } = useTranslation();
  const store = useStore.getState();

  const [state, setState] = useState(null);
  const [finalData, setFinalData] = useState(null);

  useEffect(() => {
    if (!socket) return;
    store.ref.work.methods.hostAction('mafiaMiniGameAction', { type: 'init' });

    const handleEvent = (data) => {
      if (data.type === 'update') {
        setState(data.state);
      } else if (data.type === 'finish') {
        setState(data.state);
        // Задержка, чтобы увидеть последний ход
        setTimeout(() => setFinalData(data.finalData), 600);
        window.croco?.haptic?.('success');
      } else if (data.type === 'game_over') {
         setFinalData({ my: { rank: 'FAILED', score: 0 } });
      }
    };

    socket.on('arcade:event', handleEvent);
    return () => socket.off('arcade:event', handleEvent);
  }, [socket]);

  const handleTileClick = (index) => {
    if (!state || finalData) return;
    store.ref.work.methods.hostAction('mafiaMiniGameAction', { type: 'move', index });
    // Звук "тук" (деревянный стук), в haptic используем light или medium
    window.croco?.haptic?.('impactLight');
  };

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  // --- ЭКРАН ПОБЕДЫ ---
  if (finalData) {
    const { score, moves, timeSpent, rank } = finalData.my || {};
    return (
      <div className="sliding-result-overlay">
        <div className="result-card">
          <div className="result-title">{t('arcade.sliding_unlocked', 'ЗАМОК ОТКРЫТ')}</div>

          <div className="result-row">
             <span>{t('arcade.sliding_rank', 'МАСТЕРСТВО')}</span>
             <span className="result-val">{t(`arcade.${rank}`, rank)}</span>
          </div>
          <div className="result-row">
             <span>{t('arcade.sliding_moves', 'СДЕЛАНО ХОДОВ')}</span>
             <span className="result-val">{moves}</span>
          </div>
          <div className="result-row">
             <span>{t('arcade.sliding_time', 'ЗАТРАЧЕНО ВРЕМЕНИ')}</span>
             <span className="result-val">{(timeSpent / 1000).toFixed(1)}с</span>
          </div>
          <div className="result-row" style={{ borderBottom: '2px solid #333', marginTop: '10px', fontSize: '20px' }}>
             <span>{t('arcade.sliding_score', 'НАГРАДА')}</span>
             <span className="result-val">{score}</span>
          </div>

          <button className="close-btn" onClick={onClose}>
             {t('arcade.close_case', 'ЗАБРАТЬ СОДЕРЖИМОЕ')}
          </button>
        </div>
      </div>
    );
  }

  if (!state) return null;

  const size = state.gridSize;
  // Для 3x3 шрифт ~32px, для 5x5 ~20px
  const fontSize = Math.max(18, Math.floor(100 / size));

  const gridStyle = {
    gridTemplateColumns: `repeat(${size}, 1fr)`,
    gridTemplateRows: `repeat(${size}, 1fr)`,
    aspectRatio: '1 / 1' // Пазл всегда квадратный по логике сервера
  };

  return (
    <div className="sliding-board">
      <div className="sliding-header">
        <div className="sliding-title">{t('arcade.sliding_title', 'МЕХАНИЗМ')}</div>
        <div className="sliding-stats">
          {formatTime(timeLeft)} • {t('arcade.sliding_moves_short', 'ХОДЫ')}: {state.moves}
        </div>
      </div>

      <div className="sliding-grid" style={gridStyle}>
        {state.grid.map((tileNum, index) => {
          const isEmpty = tileNum === 0;
          return (
            <div
              key={`${index}-${tileNum}`}
              className={`sliding-tile ${isEmpty ? 'empty' : ''}`}
              style={{ fontSize: `${fontSize}px` }} // Динамический шрифт
              onClick={() => !isEmpty && handleTileClick(index)}
            >
              {!isEmpty && tileNum}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SlidingPuzzle;